export function toPascalCase(text = '') {
  if (!text) return ''
  return text
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export function formatSurname(text = '') {
  if (!text) return ''
  // Remove all non-letters, trim and cut off at 20 characters
  return toPascalCase(
    text.replaceAll(/[^A-zÀ-ÖØ-öø-įĴ-őŔ-žǍ-ǰǴ-ǵǸ-țȞ-ȟȤ-ȳɃɆ-ɏḀ-ẞƀ-ƓƗ-ƚƝ-ơƤ-ƥƫ-ưƲ-ƶẠ-ỿ\s]/g, '').trim()
  ).slice(0, 20)
}

export function formatProvinceName(province) {
  return province
    .replaceAll('_', ' ') // Replace underscores with spaces
    .replaceAll(/\b\w/g, (char) => char.toUpperCase()) // Capitalize first letter of each word
}
